import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  useEffect(() => {
    const hash = window.location.hash || "";
    const m = hash.match(/token=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const token = decodeURIComponent(m[1]);
    api.get(`/auth/exchange?token=${encodeURIComponent(token)}`)
      .then(({ data }) => {
        localStorage.setItem("askt_token", data.token);
        localStorage.setItem("askt_user", JSON.stringify(data.user));
        window.location.href = "/";
      })
      .catch((e) => {
        toast.error(e?.response?.data?.detail || "Microsoft sign-in failed");
        nav("/login");
      });
  }, [nav]);
  return <div className="min-h-screen flex items-center justify-center text-ink-soft">Signing you in…</div>;
}
